var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AnalyticsSubPage,{attrs:{"title":"Pay Analytics","icon":"money-bill-wave","css-class":"analytics-pay","default-label":"Pay"}},[_c(_setup.StreamMetrics)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }